import angular, { IComponentOptions, IController } from 'angular';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
class PageEmptyStateComponentController implements IController {
  static $inject = [
    '$state',
    'sessionService',
    'tempModelerUrlService',
    'browserUtilsService',
    'permissionsService',
    'flowinglyConstants',
    'APP_CONFIG'
  ];
  private summary: string;
  private displayText: string;
  private buttonText: string;

  constructor(
    private $state: angular.ui.IStateService,
    private sessionService: SharedAngular.SessionService,
    private tempModelerUrlService: SharedAngular.TempModelerUrlService,
    private browserUtilsService: SharedAngular.BrowserUtilsService,
    private permissionsService: SharedAngular.PermissionsService,
    private flowinglyConstants: SharedAngular.FlowinglyConstants,
    private APP_CONFIG: SharedAngular.APP_CONFIG
  ) {}

  $onInit() {
    const canCreateFlowModels =
      this.permissionsService.currentUserHasPermission(
        this.flowinglyConstants.permissions.FLOWMODEL_CREATE
      );
    const isMobileDevice = this.browserUtilsService.isMobileDevice();
    const user = this.sessionService.getUser();

    switch (this.$state.current.name) {
      case STATE_MAPPINGS.flowsactive:
        this.summary = 'Hi ' + user.fullName.split(' ')[0];
        this.displayText = canCreateFlowModels
          ? `Use ${this.APP_CONFIG.brandingName} to easily map and automate your repetitive business processes.` +
            '<br /> To start a Flow, you must have at least one Workflow published to you.'
          : 'To start a Flow, you must have at least one Workflow published to you.' +
            '<br />Contact your administrator to have Flows shared with you.';
        this.buttonText =
          canCreateFlowModels && !isMobileDevice
            ? 'Create and Publish a Flow'
            : '';
        break;

      case STATE_MAPPINGS.flowstodo:
        this.summary = "Hooray, you're up to date!";
        this.displayText =
          "There are no steps requiring action from you right now that match your filter criteria.<br /> We'll notify you when there is. You can see the status of Flows that you are currently in by clicking 'Flows I'm in'.";
        this.buttonText = "See Flows I'm in";
        break;

      case STATE_MAPPINGS.flowsin:
        this.summary = 'Looks like there is nothing here';
        this.displayText =
          "This means that there are no Flows you are involved in that match your filter criteria.<br /> To start a Flow, use the 'Start Flows' tab, or click the button below.";
        this.buttonText = 'Start a Flow';
        break;

      case STATE_MAPPINGS.processmapsv2:
        this.summary = canCreateFlowModels
          ? 'You have no Process Maps'
          : 'View Process Maps';
        this.displayText = canCreateFlowModels
          ? 'We make it easy for you to create, view and share your organizational Process Maps in one place.<br /> You do not currently have any Process Maps published.'
          : 'You do not currently have any Process Maps available to view. <br /> Please contact your administrator to have relevant Process Maps shared with you.';
        this.buttonText = canCreateFlowModels ? 'Publish a Process Map' : '';
        break;

      case STATE_MAPPINGS.libraryworkflows:
      case STATE_MAPPINGS.librarydrafts:
      case STATE_MAPPINGS.libraryprocessmaps:
        this.summary = canCreateFlowModels ? 'Build your process Library' : '';
        this.displayText = canCreateFlowModels
          ? 'Get started and create your first Flow Model. <br /> Choose to publish as a Process Map that can be viewed and shared with your team. <br /> Alternatively, include powerful automation, publish as a Workflow and start running your processes.'
          : '';
        this.buttonText = canCreateFlowModels ? 'Add a Flow Model' : '';
        break;

      case STATE_MAPPINGS.libraryprocedures:
        this.summary = 'Create a SOP';
        this.displayText =
          'Use Creation Hub to create a new Standard Operating Procedure.';
        this.buttonText = '';
        break;

      case STATE_MAPPINGS.search:
        this.summary = '';
        this.displayText = 'No results found.';
        this.buttonText = '';
        break;
    }
  }

  onButtonClick(): void {
    switch (this.$state.current.name) {
      case STATE_MAPPINGS.flowsactive:
      case STATE_MAPPINGS.processmapsv2:
        this.$state.go(STATE_MAPPINGS.librarydrafts);
        break;

      case STATE_MAPPINGS.flowstodo:
        this.$state.go(STATE_MAPPINGS.flowsin);
        break;

      case STATE_MAPPINGS.flowsin:
        this.$state.go(STATE_MAPPINGS.flowsactive);
        break;
    }
  }
}

class PageEmptyStateComponent implements IComponentOptions {
  public bindings: Bindings;

  constructor() {
    this.bindings = {
      action: '<',
      actionText: '@',
      showAction: '<'
    };
  }

  transclude = true;

  controller = PageEmptyStateComponentController;

  template = `
            <div class="empty-state align-center pb-30 pt-50" ng-cloak> 
                <div class="mt-50">
                    <h4 class="empty-state__summary">{{::$ctrl.summary}}</h4>
                    <h5 class="empty-state__text" ng-bind-html="$ctrl.displayText"></h5>
                    <br />
                    <button ng-if="$ctrl.buttonText !== ''" ng-click="$ctrl.onButtonClick()" class="btn green" tabindex="auto">{{::$ctrl.buttonText}}</button>
                    <button ng-if="$ctrl.showAction && $ctrl.actionText !== ''" ng-click="$ctrl.action()" class="btn green ml-10" tabindex="auto">{{::$ctrl.actionText}}</button>
                </div>
            </div>
        `;
}

angular
  .module('flowingly.runner.directives')
  .component('runnerPageEmptyState', new PageEmptyStateComponent());
